import type { KeyboardEvent } from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { MAX_SEARCH_LENGTH } from './searchInput';

interface BrowserSearchBoxProps {
    label: string;
    value: string;
    placeholder: string;
    controls: string;
    disabled?: boolean;
    onChange: (value: string) => void;
}

export function BrowserSearchBox({
    label,
    value,
    placeholder,
    controls,
    disabled = false,
    onChange
}: BrowserSearchBoxProps) {
    // Escape clears a non-empty box; from an empty one it closes the open pane, else the modal.
    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key !== 'Escape' || value === '') return;
        event.preventDefault();
        event.stopPropagation();
        onChange('');
    };

    return (
        <div role="search" className="relative min-w-[240px] max-w-[360px] flex-[1_1_320px]">
            <MagnifyingGlassIcon
                className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
                aria-hidden="true"
            />
            <input
                type="search"
                value={value}
                placeholder={placeholder}
                aria-label={label}
                aria-controls={controls}
                maxLength={MAX_SEARCH_LENGTH}
                disabled={disabled}
                autoComplete="off"
                spellCheck={false}
                onChange={(event) => onChange(event.target.value)}
                onKeyDown={handleKeyDown}
                className="h-9 w-full rounded-lg border border-gray-200 bg-white pl-9 pr-3 text-[13px] text-gray-900 placeholder-gray-400 transition-colors focus:border-gray-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-200 disabled:cursor-not-allowed disabled:bg-gray-50"
            />
        </div>
    );
}
